<script setup>
import { onMounted, onUnmounted } from "vue";
import ArtworkNeckLine from "./ArtworkNeckLine.vue";
import { getDisplayedSize } from "../../utils/sizes";

const emit = defineEmits([
  "update-neck-line-label",
  "update-neck-line-height",
  "clear-custom-neck-lines",
  "reset-neck-line",
  "track-custom-placement",
  "init-previews-values"
]);
const props = defineProps({
  neckLineLabel: {
    type: String,
    required: false,
    default: ""
  },
  customNeckLines: {
    type: Object,
    required: true
  },
  neckLines: {
    type: Object,
    required: true
  },
  maxDistance: {
    type: Function,
    required: true
  }
});

const getPosition = label => {
  const index = Object.keys(props.neckLines).indexOf(label);
  if (index === 0) return "left";
  if (index === Object.keys(props.neckLines).length - 1) return "right";
  return "center";
};

const setDefaultNeckLine = () => {
  const [neckLine] = Object.keys(props.neckLines);
  emit("update-neck-line-label", neckLine);
  emit("init-previews-values");
};

const lineValue = (prop, label) =>
  getDisplayedSize(
    Math.min(props.customNeckLines[label] ?? prop.default, props.maxDistance(prop.max_height))
  );

onMounted(setDefaultNeckLine);
onUnmounted(() => {
  emit("clear-custom-neck-lines");
});
</script>

<template>
  <div class="artwork-neck-lines">
    <div v-for="(prop, label) in props.neckLines" :key="label" class="artwork-neck-lines__item">
      <ArtworkNeckLine
        :default="getDisplayedSize(prop.default)"
        :value="lineValue(prop, label)"
        :label="label"
        :position="getPosition(label)"
        :active="props.neckLineLabel === label"
        @update-neck-line-label="emit('update-neck-line-label', $event)"
        @update-neck-line-height="emit('update-neck-line-height', $event)"
        @reset-neck-line="emit('reset-neck-line', $event)"
        @track-custom-placement="emit('track-custom-placement', $event)"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.artwork-neck-lines {
  display: flex;
  overflow: auto hidden;
  margin: 0 -12px -12px;
  padding: 0 12px 12px;

  &__item {
    flex: 0 0 94px;
  }
}
</style>
